import {
	formatRow,
	formatCell,
	formatDate,
	formatLabel,
	formatNumber,
	formatChambre,
	formatNumeroFromUid,
	formatTexteLegislatif,
	formatActeurSansGroupe,
} from "../formatters";
import { AmendmentIcon } from "@logora/parliament.icons.regular_icons";

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date de dépôt",
		accessorKey: "dateDepot",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date de dépôt",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Auteur",
		accessorKey: "acteurRef",
		cell: (info) => formatActeurSansGroupe(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Numéro",
		accessorKey: "uid",
		cell: (info) => formatNumeroFromUid(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Numéro",
			},
		},
	},
	{
		header: "Texte",
		accessorKey: "documentRef",
		cell: (info) => formatTexteLegislatif(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Article",
		accessorKey: "divisionTitre",
		enableSorting: false,
	},
	{
		header: "Subdivision",
		accessorKey: "subdivisionRefHash",
		enableSorting: false,
		isVisible: false,
		meta: {
			filter: {
				label: "Article",
				variant: "async-select",
				key: "subdivisionRefHash",
				resource: "subdivisions",
				perPage: 100,
				sort: { field: "sequence", order: "ASC" },
				filters: { type: "Article" },
				getOptionLabel: (option) => `${option?.titre}`,
				getOptionValue: (option) => option?.hash,
				isOptionEqualToValue: (option, value) => {
					return option?.hash === value
				}
			},
		},
	},
	{
		header: "Nombre de co-signataires",
		accessorKey: "nombreCoSignataires",
		cell: (info) => formatNumber(formatCell(info)),
	},
	{
		header: "Sort",
		accessorKey: "sortAmendement",
		cell: (info) => formatLabel(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Sort",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Adopté", label: "Adopté" },
					{ value: "Rejeté", label: "Rejeté" },
					{ value: "En traitement", label: "En traitement" },
					{ value: "A discuter", label: "À discuter" },
					{ value: "Retiré", label: "Retiré" },
					{ value: "Irrecevable", label: "Irrecevable" },
					{ value: "Irrecevable 40", label: "Irrecevable 40" },
					{ value: "Tombé", label: "Tombé" },
				],
			},
		},
	},
];

export const amendementDataset = {
	key: "amendements",
	name: "Amendements",
	columns: columns,
	filterMapping: {
		organeRefUid: "acteurRef_groupeParlementaireUid",
		dossierRefUid: "documentRef_dossierRefUid",
		amendementRefUid: "uid",
	},
	searchPlaceholder: "Rechercher un amendement...",
	include: [
		"acteurRef.groupeParlementaire",
		"acteurRef.mandatPrincipal",
		"documentRef.dossierRef",
		"gouvernementOrganeRef",
	],
	icon: <AmendmentIcon height={20} width={20} />,
};
